import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  const whatsappNumber = '818012345678'; // 実際の電話番号に置き換えてください
  const whatsappMessage = encodeURIComponent('Hello, I would like to book the Driving Assistant service.\nDate:\nTime:\nNumber of people:');
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden film-grain">
      {/* Background Image with Sepia Filter */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ed4f4874fe55791d91b0b878d48783a9.jpg"
          alt="Showa Retro Kominka"
          className="w-full h-full object-cover sepia-filter"
        />
        {/* Warm Amber Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-showa-darkBrown/60 via-showa-brown/40 to-showa-darkBrown/70"></div>
        {/* Film Grain Overlay */}
        <div className="absolute inset-0 opacity-20 mix-blend-overlay" 
             style={{
               backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='3' numOctaves='5' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
             }}>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        {/* Retro Badge */}
        <div className="inline-block mb-8 px-6 py-2 border-2 border-showa-gold bg-showa-darkBrown/80 backdrop-blur-sm">
          <span className="text-showa-gold font-retro text-sm tracking-widest">EST. 1970s STYLE</span>
        </div>

        {/* Main Heading - Typewriter Style */}
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-bold text-showa-cream mb-6 retro-text-shadow leading-tight">
          Showa Retro Stay
          <span className="block text-showa-gold mt-2">in Tokyo</span>
        </h1>

        {/* Subtitle */}
        <p className="text-xl md:text-2xl text-showa-cream/90 font-serif mb-4 max-w-3xl mx-auto leading-relaxed">
          Step into a 1970s Japanese Time Capsule
        </p>

        <p className="text-base md:text-lg text-showa-warmGray font-light mb-12 max-w-2xl mx-auto leading-relaxed">
          Experience authentic Showa-era living in our vintage kominka house near Haneda Airport. 
          Feel like you've walked into a classic Japanese film.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#reservation"
            className="group px-8 py-4 bg-transparent hover:bg-showa-cream/10 text-showa-cream font-serif text-lg transition-all duration-300 border-2 border-showa-cream backdrop-blur-sm whitespace-nowrap cursor-pointer"
          >
            <span className="flex items-center gap-3">
              Direct Booking
              <i className="ri-mail-line text-xl"></i>
            </span>
          </a>

          <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="group px-8 py-4 bg-gradient-to-r from-[#25D366] to-[#128C7E] hover:from-[#128C7E] hover:to-[#075E54] text-white font-serif text-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer rounded-full"
          >
            <span className="flex items-center gap-3">
              Book via WhatsApp
              <i className="ri-whatsapp-line text-xl"></i>
            </span>
          </a>
        </div>

        {/* Retro Decorative Elements */}
        <div className="mt-16 flex justify-center gap-8 text-showa-gold/60">
          <div className="flex flex-col items-center">
            <i className="ri-home-4-line text-3xl mb-2"></i>
            <span className="text-xs font-retro tracking-wider">WHOLE HOUSE</span>
          </div>
          <div className="w-px h-12 bg-showa-gold/30"></div>
          <div className="flex flex-col items-center">
            <i className="ri-flight-takeoff-line text-3xl mb-2"></i>
            <span className="text-xs font-retro tracking-wider">25 MIN FROM HANEDA</span>
          </div>
          <div className="w-px h-12 bg-showa-gold/30"></div>
          <div className="flex flex-col items-center">
            <i className="ri-time-line text-3xl mb-2"></i>
            <span className="text-xs font-retro tracking-wider">1970s AUTHENTIC</span>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="flex flex-col items-center gap-2 text-showa-cream/70">
          <span className="text-xs font-retro tracking-widest">SCROLL</span>
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}